module.exports = __webpack_public_path__ + "static/BasinBulteni_Catalyst_Sprint3_tr-37c6931449dfbfbe03b4d5acc9c069fe.png";